(function () {

	'use strict';

    let cologicCustomActionhandle = {

        baseUrl: $('base').prop('href'),



        // actionHandlerURL:  this.baseUrl + "index.php?id=18",

        getTtContentElement: function(_id, _elem) {

            let param = '&ttid=' + _id;
            this.queryActionHandler(false, 'getTtContentElementFromId', param, function(response_Data){
                if (response_Data) {
                    $('.'+_elem).html(response_Data);

                } else {
                    $('.'+_elem).html('Ihre Suche ergab keine Treffer, bitte ändern Sie Ihre Suchparameter');
                }
            });


        },

        getHtmlContent: function (mapHandlerURL, ajaxCallback){
            var response;

        var trgAdress = mapHandlerURL;
        $.ajax({
            type: 'get',
            context: document,
            // cache: false,
            url: trgAdress
        })
            .done(function(data) {
                try{
                    // var response;
                    response = data.trim();
                    // queryActionHandler_retVal = response;

                    // if(ajaxCallback != undefined) ajaxCallback.call();
                    if (ajaxCallback)
                        ajaxCallback(response);

                    return(response);

                }catch(err){
                    alert("Fehler: " + err);
                }
            })
            .fail(function(err) {
                alert("Es ist ein Fehler aufgetreten: " + err);
            });

    },




    queryActionHandler: function(handleAsJson, act, params, ajaxCallback) {
            let actionHandlerURL=this.baseUrl + "index.php?id=18";

            let trgAdress = this.actionHandlerURL + '&act=' + act + params;
            $.ajax({
                type: 'get',
                cache: false,
                url: trgAdress
            })
                .done(function (data) {
                    try {
                        let response;
                        //remove BOM + parse json
                        if (handleAsJson) {
                            response = $.parseJSON(data.trim());
                        } else {
                            response = data.trim();
                        }

                        if (ajaxCallback)
                            ajaxCallback(response);
                        return (response);

                    } catch (err) {
                        alert("Fehler: " + err);
                    }
                })
                .fail(function (err) {
                    // console.log(err);
                    alert("Es ist ein Fehler aufgetreten: " + err);
                });

        }

    }
	//gemeinsam verfügbar machen
	if (typeof (cologic) === 'undefined')
		window.cologic = {};
	$.extend(cologic, cologicCustomActionhandle);
}());